export class UserCannotBeRemovedFromCourtSystemError extends Error {
  constructor(message: string) {
    super(message)
    Object.setPrototypeOf(this, UserCannotBeRemovedFromCourtSystemError.prototype)
  }
}
